import Chip from "@mui/material/Chip";
import Link from "@mui/material/Link";
import TableCell from "@mui/material/TableCell";
import Typography from "@mui/material/Typography";
import PlaceIcon from "@mui/icons-material/Place";
import { formatThaiShortDate } from "../../utils/date";
import { formatCount } from "../VisitFrequency/visitFrequency";
import { MISSING, daysTone, mapsUrl, noBillLabel, toneSx } from "./inactiveStores";

// Cells shared by the detail table and the popup, so a shop reads the same in both.

const MAP_LINK_LABEL = "เปิดตำแหน่งร้านใน Google Maps";

export function DaysCell({
  days,
  lookbackDays,
}: Readonly<{ days: number | null; lookbackDays: number }>) {
  if (days === null) {
    return (
      <TableCell align="right">
        <Typography variant="caption" color="text.secondary">
          {noBillLabel(lookbackDays)}
        </Typography>
      </TableCell>
    );
  }
  return (
    <TableCell align="right">
      <Chip size="small" label={formatCount(days)} sx={toneSx(daysTone(days))} />
    </TableCell>
  );
}

export function LastSaleCell({ date }: Readonly<{ date: string | null }>) {
  return <TableCell>{formatThaiShortDate(date, { weekday: false }) || MISSING}</TableCell>;
}

export function MapLinkCell({
  latitude,
  longitude,
}: Readonly<{ latitude: number | null; longitude: number | null }>) {
  const url = mapsUrl(latitude, longitude);
  return (
    <TableCell align="center">
      {url ? (
        <Link
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={MAP_LINK_LABEL}
          title={MAP_LINK_LABEL}
        >
          <PlaceIcon fontSize="small" color="error" />
        </Link>
      ) : (
        MISSING
      )}
    </TableCell>
  );
}
